export const OPERATORS = {
  EQ: "eq",
  IS_TRUE: "isTrue",
  IS_FALSE: "isFalse"
};

export const OPERATOR_LABEL_MAP = {
  [OPERATORS.EQ]: "is equal",
  [OPERATORS.IS_TRUE]: "is true",
  [OPERATORS.IS_FALSE]: "is false"
};

export const OPERATOR_FIXED_VALUE = {
  [OPERATORS.IS_TRUE]: true,
  [OPERATORS.IS_FALSE]: true
};

export const OPERATOR_OPTIONS = [
  {
    uid: "",
    label: "n/a"
  },
  {
    uid: OPERATORS.EQ,
    label: OPERATOR_LABEL_MAP[OPERATORS.EQ]
  },
  {
    uid: OPERATORS.IS_TRUE,
    label: OPERATOR_LABEL_MAP[OPERATORS.IS_TRUE]
  },
  {
    uid: OPERATORS.IS_FALSE,
    label: OPERATOR_LABEL_MAP[OPERATORS.IS_FALSE]
  }
];
